"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMouseTracker = void 0;
var _react = require("react");
var _browserDetect = require("../utils/browser-detect");
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var useMouseTracker = function useMouseTracker() {
  var internalTargetRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMouseIn = _useState2[0],
    setIsMouseIn = _useState2[1];
  var _useState3 = (0, _react.useState)({
      clientX: 0,
      clientY: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    mousePosition = _useState4[0],
    setMousePosition = _useState4[1];
  var customCursor = (0, _react.useMemo)(function () {
    return !(0, _browserDetect.isMS)() && !(0, _browserDetect.hasTouch)();
  }, []);
  var targetRef = (0, _react.useCallback)(function (node) {
    internalTargetRef.current = node;
  }, []);
  var handleMouseEnter = (0, _react.useCallback)(function (_ref) {
    var clientX = _ref.clientX,
      clientY = _ref.clientY;
    setMousePosition({
      clientX: clientX,
      clientY: clientY
    });
    setIsMouseIn(true);
  }, []);
  var handleMouseLeave = (0, _react.useCallback)(function () {
    return setIsMouseIn(false);
  }, []);
  (0, _react.useEffect)(function () {
    var currentTargetRef = internalTargetRef.current;
    if (customCursor && currentTargetRef) {
      currentTargetRef.addEventListener("mouseenter", handleMouseEnter);
      currentTargetRef.addEventListener("mouseleave", handleMouseLeave);
    }
    return function () {
      if (customCursor && currentTargetRef) {
        currentTargetRef.removeEventListener("mouseenter", handleMouseEnter);
        currentTargetRef.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, [customCursor, handleMouseEnter, handleMouseLeave]);
  return {
    targetRef: targetRef,
    data: {
      mousePosition: mousePosition,
      isMouseIn: isMouseIn
    }
  };
};
exports.useMouseTracker = useMouseTracker;